"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DndContainer = exports.DndAutoScroll = exports.DragListItem = exports.DropTarget = exports.DragWithHandle = exports.Drag = exports.DragTypes = void 0;
var React = require("react");
var react_1 = require("react");
var react_dnd_1 = require("react-dnd");
var typestyle_1 = require("typestyle");
var react_dnd_multi_backend_1 = require("react-dnd-multi-backend");
var HTML5toTouch_1 = require("react-dnd-multi-backend/dist/cjs/HTML5toTouch");
var generic_1 = require("../generic");
var DragTypes = (function () {
    function DragTypes() {
    }
    DragTypes.NONE = "none";
    DragTypes.ANY = "any";
    return DragTypes;
}());
exports.DragTypes = DragTypes;
function Drag(props) {
    var ref = (0, react_1.useRef)(null);
    var _a = __read((0, react_dnd_1.useDrag)({
        item: props.item,
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging(),
        }); }
    }), 2), isDragging = _a[0].isDragging, drag = _a[1];
    var base = "DragItem";
    var disabled = props.disabled && "DragItem--disabled";
    var dragging = isDragging && "DragItem--dragging";
    var placeholder = isDragging && "DragItem__Placeholder";
    if (!props.disabled)
        drag(ref);
    return (React.createElement("div", { className: (0, typestyle_1.classes)(placeholder) },
        React.createElement("div", { ref: ref, className: (0, typestyle_1.classes)(base, disabled, dragging) }, props.children)));
}
exports.Drag = Drag;
function DragWithHandle(props) {
    var ref = (0, react_1.useRef)(null);
    var _a = __read((0, react_dnd_1.useDrag)({
        item: props.item,
        collect: function (monitor) { return ({
            isDragging: monitor.isDragging(),
        }); }
    }), 3), isDragging = _a[0].isDragging, drag = _a[1], preview = _a[2];
    var base = "DragItemWithHandle";
    var dragging = isDragging && "DragItem--dragging";
    var placeholder = isDragging && "DragItem__Placeholder";
    var handle = "DragItem__Handle";
    var disabled = props.disabled && "DragItem__Handle--disabled";
    if (!props.disabled)
        drag(ref);
    return (React.createElement("div", { className: (0, typestyle_1.classes)(placeholder) },
        React.createElement("div", { className: (0, typestyle_1.classes)("row", dragging) },
            React.createElement("div", { ref: ref, className: (0, typestyle_1.classes)(handle, disabled) },
                React.createElement("div", { className: (0, typestyle_1.classes)("btn", "btn-link", props.disabled && "disabled") },
                    React.createElement(generic_1.Icon, { name: generic_1.Icons.grip_vertical }))),
            React.createElement("div", { ref: preview, className: (0, typestyle_1.classes)(base) }, props.children))));
}
exports.DragWithHandle = DragWithHandle;
function DropTarget(props) {
    var _a = __read((0, react_dnd_1.useDrop)({
        accept: props.accept,
        hover: props.onHover,
        drop: props.onDrop,
        canDrop: props.canDrop,
        collect: function (monitor) { return ({
            highlighted: monitor.canDrop(),
            hovered: monitor.isOver(),
        }); }
    }), 2), _b = _a[0], highlighted = _b.highlighted, hovered = _b.hovered, drop = _a[1];
    var base = "DropTarget";
    var canDrop = highlighted ? "DropTarget--highlight" : "";
    var isHovered = hovered ? "DropTarget--hovered" : "";
    return (React.createElement("div", { ref: drop, className: (0, typestyle_1.classes)(base, canDrop, isHovered) }, props.children));
}
exports.DropTarget = DropTarget;
function DragListItem(props) {
    var ref = (0, react_1.useRef)(null);
    var onHover = function (item, monitor) {
        if (!ref.current)
            return;
        if (props.canDrop && !props.canDrop(item))
            return;
        var targetRect = ref.current.getBoundingClientRect();
        var mousePosition = monitor.getClientOffset();
        var targetHalf = (targetRect.bottom - targetRect.top) / 2;
        var mouseRelativeY = mousePosition.y - targetRect.top;
        var goingDown = monitor.getClientOffset().y > monitor.getInitialClientOffset().y;
        var goingUp = !goingDown;
        var passedLower = goingDown && mouseRelativeY > targetHalf;
        var passedHigher = goingUp && mouseRelativeY < targetHalf;
        if (passedLower || passedHigher) {
            props.moveItem(item);
        }
    };
    return (React.createElement("li", { ref: ref, className: props.className },
        React.createElement(DropTarget, { accept: props.disabled ? DragTypes.NONE : props.accept, canDrop: props.canDrop, onHover: onHover },
            React.createElement(DragWithHandle, { item: props.dragItem, disabled: props.disabled }, props.children))));
}
exports.DragListItem = DragListItem;
function DndAutoScroll(props) {
    var onHover = function (item, monitor) {
        var scrollTop = $(props.scrollParentId || document).scrollTop();
        var dragDistance = monitor.getDifferenceFromInitialOffset().y;
        var scrollStep = 20;
        if (Math.abs(dragDistance) >= scrollStep) {
            $(props.scrollParentId || "html").animate({
                scrollTop: scrollTop + Math.ceil(dragDistance / scrollStep),
            }, {
                duration: 0,
                queue: false,
            });
        }
    };
    return (React.createElement(DropTarget, { accept: DragTypes.ANY, canDrop: function () { return false; }, onHover: onHover }, props.children));
}
exports.DndAutoScroll = DndAutoScroll;
var DndContainer = function (props) {
    return (React.createElement(react_dnd_multi_backend_1.DndProvider, { options: HTML5toTouch_1.default }, props.children));
};
exports.DndContainer = DndContainer;
